import {differenceInYears} from 'date-fns';
//constantes
import { baseURL as baseURLDefault } from '../config/http';
export const baseUrl = baseURLDefault;
export const maxRecargaValue = 500
export const regexEmail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/
export const arrayOptionsUF = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MS","MT","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"]
export const messagemGiroSucesso = "Cartão adicionado com sucesso! Seus créditos serão transferidos em até 5 dias úteis."
export const objectBalanceWidth = {
    step:11,
    cardBalance:{
        initial:260
    },
    promoBalance:{
        initial:343,
    },
    creditBalance:{
      initial:265
    }
}
export const popupMessages = {
    title:{
        ok:"Sucesso",
        okExclamacao:"Sucesso!",
        att:"Atenção",
        err:"Erro",
        sRec:"Senha recuperada"
    },
    message:{
        sEdit:"Usuário Alterado Com Sucesso",
        sNew:"Usuário Criado com Sucesso",
        sNewEmailSms:"Conta criada com sucesso. Você receberá seu código de ativação por e-mail.",
        eRecarga:"Recarga não efetuada",
        sRec:"Você receberá no seu e-mail uma nova senha provisória, lembre de altera-la quando acessar novamente o aplicativo"
    },
    optionalMessage:{
        sGiroCard:"Sucesso ao Adicionar Cartão",
        eGiroCard:"Erro ao Adicionar Cartão"
    },
    cardBlock: {
        validation: 'Ops, identificamos um problema no seu cartão. Dirija-se a uma estação e troque gratuitamente.',
        modal: {
            title: 'Encontramos um problema.',
            message: 'Ops, identificamos um problema no seu cartão. Dirija-se a uma estação e realize a troca gratuitamente. Em caso de dúvida, acesse o chat no site MetrôRio.'
        }
    }
}
 
//functions
export const testaSenha = regexSenha => regexSenha && regexSenha.length >= 8 && !!regexSenha.match(/[a-z]+/) && !!regexSenha.match(/[A-Z]+/) && !!regexSenha.match(/[0-9]+/)
export const retornaArray = (fim,comeco=1) => ([...Array(fim+1).keys()].slice(comeco))

export const redirect = (name,self) =>{ 
    self.$router.currentRoute.name !== name && self.$router.push({name})
}
export const scrollTop = () => (scrollTo({top: 0,behavior: 'smooth'}))
export const buscaCep = async cep => await fetch(`http://viacep.com.br/ws/${cep}/json/`).then(data=> data.json())
export const isTablet = () => window.innerWidth > 520 && window.innerWidth && window.innerWidth < 1024
export const isMobile = () => window.innerWidth < 520
export const hideCpf = (cpf,foreigner) => foreigner ? `*****${cpf.slice(-3)}` : `***.***.${cpf.slice(-5,-2)}-${cpf.slice(-2)}`
export const reversedDate = date => `${date.split("/")[1]}/${date.split("/")[0]}/${date.split("/")[2]}`
export const testDate = value => {
    if(!value) return true
    const data = reversedDate(value)
    return (new Date(data).toString() !== "Invalid Date" && new Date(data) < new Date() )    
}

export const formatDate = date => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day,month,year].join('/');
}
export const formatDateToSend = date =>{
    if(!date) return 
    const data = reversedDate(date)
    return new Date(data).toISOString()
} 
export const saveToken = self => ({data}) => {
    const 
     {accessToken,refreshToken} = data
     
     sessionStorage.setItem("giro-token",accessToken)
     sessionStorage.setItem("refresh-token",refreshToken)
     //redirect("home",self)
     redirect("bilhete-especial",self)
     self.$emit('login')
     
}
export const removeToken = () => {
    sessionStorage.removeItem('refresh-token')
    sessionStorage.removeItem('giro-token')
}
export const formatMoney = number => `${(parseFloat(number)/100).toFixed(2).replace(".",",")}`

export const unFormatMoney = string => {
    if(!string) return 0 
    const 
        onlyNumber = string.replace("R$",'').trim(),
        centavos = onlyNumber.slice(-2),
        reais = onlyNumber.substring(0,onlyNumber.length-3).replace('.','')

    return (Number(`${reais}${centavos}`))
}
export const emitToParent = (fnName,self,value) => self.$emit(fnName,value)
export const returnPopupObject = function(keyTitle,keyMessage,keyOptionalMessage) {
    return ({
        title:(popupMessages.title[keyTitle] || keyTitle),
        optionalMessage:(popupMessages.optionalMessage[keyOptionalMessage] || keyOptionalMessage) ,
        message:(popupMessages.message[keyMessage] || keyMessage),
        dialog:true
    })
}
export const retrieveMyUser = self => self.$emit('retrieveMyUser')

export const handleError = ({response},cb,self) => {
    console.log({response})
    if(!response) return cb("Algo deu Errado")
    const 
        {data,config,status} = response,
        isWrongPassword = data.message === "Invalid Credentials",
        isLogin = config.url.indexOf("api/login") > -1,
        isGiroCard = config.url.indexOf("girocard") > -1,
        isRecoverPassword = config.url.indexOf("/api/users/recoverpassword") > -1,
        isInactive = data.message === "Invalid Activation Code",
        isGiroInvalid = data.cod === "400#0006",
        isGiroExist = data.cod === "400#0002";
    if(data.cod === "400#0008") return cb("CARD-BLACK-LIST")
    if(data.cod === "400#0009") return cb("CARD-DISSOCIATED")
    if(isGiroCard && status === 400){
        if(isGiroInvalid) return cb("Cartão giro inválido ou existente para outro usuário.")
        if(isGiroExist) return cb("Já existe um cartão Giro ativo para esse usuário.")
        return cb("Erro ao salvar cartão Giro.")
    }
    if(isRecoverPassword && status === 404){
        return cb("não achei")
    }
    if(data.cod === "400#0006" && data.message === "Invalid Giro Card"){
        return cb("Cartão giro inválido ou existente para outro usuário.")
    }
   
    if(isWrongPassword && isLogin) if(cb) return cb("Usuário ou Senha Inválidos")
    if(isInactive && isLogin) if(cb) return cb("Por favor insira o token recebido por e-mail para acessar sua conta Giro.")
    if(data.message === "Unauthorized User" && isLogin) {
        return cb("")
    }
    if(status === 400 && data.title === "One or more validation errors occurred."){
        return cb("Por favor verifique os campos do formulário")
    }
    if(status=== 400 && data.message === "User Already Exists"){
        return cb("Usuário já existe")
    }
    if(status === 401 && !isLogin && sessionStorage.getItem("giro-token")){
        sessionStorage.setItem("erroRedirect","aqui")
        return redirect("login",self)
    } 
    if(status === 401 && isLogin && data.errorNumber == 403 &&  (data.mensagem||'').indexOf("Usuário Bloqueado") !== -1) {
        return cb('Usuário Bloqueado. Entre em contato com o SAC.');
    }
    
    return cb("Erro ao fazer a chamada")
}
export const resolvePromise = async (promise,cb,errCb,self) =>{
    try {
        const data = await promise
        return cb ? cb(data) : data
    } catch (error) {
        handleError(error,errCb,self)
    }
    
}

//https://www.devmedia.com.br/validar-cpf-com-javascript/23916
export const validaCpf = cpf => {
    var Soma;
    var Resto;
    Soma = 0;
    var i;
    if(!cpf) return false
  cpf = cpf.replace(/\D+/g, '')
  if (cpf == "00000000000") return false;
     
  for (i=1; i<=9; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;
   
    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(cpf.substring(9, 10)) ) return false;
   
  Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;
   
    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(cpf.substring(10, 11) ) ) return false;
    return true;
}
export const isUnderYearsOld = (date, years)  => {
    if(!testDate(date)) return true;
    const dateReverse = (date||"").split('/').reverse().join('-');
    /*const diffTime = Math.abs(new Date() - new Date(dateReverse));
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    const diffInYears = Math.floor(diffDays / 365);*/
    const diffInYears = differenceInYears(new Date(), new Date(dateReverse));
    return diffInYears < years;
  }